import { PracticeProfile } from '../types/practice'

export const transformPractices = (practices: PracticeProfile[]) =>
  practices.map((pr) => ({
    ...pr,
    // todo: temporary big page size fix
    // Keywords and specialists from practice currently is not in use but increase the page size significantly.
    // Keep this solution unless we figure out how to deal with big amount of data in keywords.

    keywords_search: [],
    specialists: [],
    keywords: [],
    insurers: []
  }))
